/**
 * 账号设置
 *
 **/

import React from 'react';
import { Button, Card, Col, Form, Icon, Input, message, Modal, Popconfirm, Row, Table, Dropdown, Switch, Menu } from 'antd';
import { fetchLoginedUser } from "../../redux/actions/user";
import { findSubUserAllCheckinpoints, deleteSubUserAllCheckinpoint } from "../../services/checkinpoint";
import {
    findSubAccounts, createSubAccounts, deleteSubAccount,
    updateSubAccountResetPwd, updateSubAccountResetLoginname, createOrgName,
    findSubAccountExp, updateSubAccountExp,
    findSubAccountGuest, updateSubAccountGuest,
    findSubAccountAudit, updateSubAccountAudit,
    findSubAccountAttendee,updateSubAccountAttendee
} from "../../services/subAccounts";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import styled from "styled-components";
import Holder from "../../components/Holder";
import { CopyToClipboard } from 'react-copy-to-clipboard';
import PurchaseServiceTips from "../PurchaseServiceTips";
import { isValidity } from "../../services/global";


const ASBody = styled.div`
    min-height: 500px;
`;
const mapStateToPorps = state => {
    const cmEnums = state.cmEnums;
    const loginedUser = state.loginedUser;
    return { cmEnums, loginedUser };
};
const mapDispatchToProps = dispatch => ({
    fetchLoginedUser: bindActionCreators(fetchLoginedUser, dispatch),
});
class SubAccList extends React.Component {

    constructor(props) {
        super(props);
        console.log(props)
        this.checkinpointColumns = [{
            title: '签到点名称',
            dataIndex: 'name',
            width: 250,
        }, {
            title: '所属活动',
            dataIndex: 'event.name',
            width: 190,
        }, {
            title: '操作',
            dataIndex: 'title',
            width: 80,
            render: (text, record, index) => {
                return <span>
                    <Popconfirm title={<span>您确定要解除签到点 <span className="mdc-text-red">{record.name}</span> 绑定吗？</span>}
                        placement="leftBottom"
                        onConfirm={(e) => {
                            deleteSubUserAllCheckinpoint({ checkinpointId: record.id, subUserId: this.state.subUserId }).then(res => {
                                if (res.code == 200) {
                                    message.info("解除成功!");
                                    this.fetchFilterTableData();
                                } else {
                                    message.error(res.msg, 6);
                                }
                            }).catch(err => {
                                message.warn("访问异常");
                            })
                        }}
                        okText="确定"
                        cancelText="放弃">
                        <a href="#">解除绑定</a>
                    </Popconfirm>

                </span>
            },
        },];
        this.state = {
            data: [],
            visible: false,
            pwdVisible: false,
            formLoading: false,
            record: null,
            checkinpointResponse: {
                isFetching: true,
                data: [],
                pagination: {
                    total: 0,
                    defaultPageSize: 20,
                    current: 1,
                },
            },
        }
    }

    componentDidMount() {
        this.fetchData();
        this.fetchSubAccountData();
    }

    fetchData = () => {
        findSubAccounts({ userId: 'default' }).then(res => {
            if (res.code === 200) {
                this.setState({ data: res.data });
            } else {
                message.error(res.msg, 6);
            }
        }).catch(err => {
            message.warn("访问异常");
        });
    }
    fetchSubAccountData = () => {
        findSubAccountExp().then(res => {
            if (res.code === 200) {
                this.setState({ expSwitch: res.data });
            } else {
                message.error(res.msg, 6);
            }
        }).catch(err => {
            message.warn("访问异常");
        });
        findSubAccountGuest().then(res => {
            if (res.code === 200) {
                this.setState({ guestSwitch: res.data });
            } else {
                message.error(res.msg, 6);
            }
        }).catch(err => {
            message.warn("访问异常");
        });
        findSubAccountAudit().then(res => {
            if (res.code === 200) {
                this.setState({ AuditSwitch: res.data });
            } else {
                message.error(res.msg, 6);
            }
        }).catch(err => {
            message.warn("访问异常");
        });
        findSubAccountAttendee().then(res => {
            if (res.code === 200) {
                this.setState({ AtendeeSwitch: res.data });
            } else {
                message.error(res.msg, 6);
            }
        }).catch(err => {
            message.warn("访问异常");
        });
    }
    updateSubAccountData = (e) => {
        updateSubAccountExp({ allowSubAccountExport: e }).then(res => {
            if (res.code === 200) {

            } else {
                message.error(res.msg, 6);
            }
        }).catch(err => {
            message.warn("访问异常");
        });
    }
    updateSubAccountAuditData = (e) => {
        updateSubAccountAudit({ allowAudit: e }).then(res => {
            if (res.code === 200) {

            } else {
                message.error(res.msg, 6);
            }
        }).catch(err => {
            message.warn("访问异常");
        });
    }
    updateSubAccountAttendeeData = (e) => {
        updateSubAccountAttendee({ allowAudit: e }).then(res => {
            if (res.code === 200) {

            } else {
                message.error(res.msg, 6);
            }
        }).catch(err => {
            message.warn("访问异常");
        });
    }
    onHandleSubAccountGuest = (e) => {
        updateSubAccountGuest({ must: e }).then(res => {
            if (res.code === 200) {

            } else {
                message.error(res.msg, 6);
            }
        }).catch(err => {
            message.warn("访问异常");
        });
    }

    handleDelSubAccount = (id) => {
        deleteSubAccount({ id: id, userId: 'default' }).then(res => {
            if (res.code === 200) {
                message.success("删除成功");
                this.fetchData();
            } else {
                message.error(res.msg, 6);
            }
        }).catch(err => {
            message.warn("访问异常");
        });
    }

    handleModalVisible = (flag) => {
        this.setState({ visible: flag });
    }
    showModalVisiblePwd = (record) => {
        this.setState({
            record: record
        }, () => this.setState({ pwdVisible: true }))

    }
    showModalVisibleLoginname = (record) => {
        this.setState({
            record: record
        }, () => this.setState({ loginnameVisible: true }))

    }
    showCheckinpointModal = (id) => {
        this.setState({
            checkinpointVisible: true,
            subUserId: id
        }, () => {
            this.fetchFilterTableData()
        })

    }
    fetchFilterTableData = () => {
        const checkinpointResponse = { ...this.state.checkinpointResponse };
        checkinpointResponse.isFetching = true;
        this.setState({
            checkinpointResponse: checkinpointResponse
        }, () => {
            findSubUserAllCheckinpoints({ subUserId: this.state.subUserId }).then(res => {
                if (res.code === 200) {
                    checkinpointResponse.data = res.data;
                    checkinpointResponse.isFetching = false;
                    this.setState({ checkinpointResponse: checkinpointResponse });
                } else {
                    message.error(res.msg, 6);
                }
            }).catch(err => {
                message.warn("访问异常");
            });

        })
    }

    changeFormLoading = (loading) => {
        this.setState({
            formLoading: loading
        })
    }

    submitForm = (e) => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.changeFormLoading(true)
                createSubAccounts(Object.assign({ userId: 'default' }, values)).then(res => {
                    if (res.code === 200) {
                        message.success("添加成功!");
                        this.handleModalVisible(false);
                        this.fetchData();
                    } else {
                        message.error(res.msg, 6);
                    }
                }).catch(err => {
                    message.warn("访问异常");
                }).finally(() => {
                    this.changeFormLoading(false)
                });
            }
        });
    }
    updatePwd = (e) => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.changeFormLoading(true)
                updateSubAccountResetPwd(Object.assign({ subUserId: this.state.record.id }, values)).then(res => {
                    if (res.code === 200) {
                        message.success("修改成功!");
                        this.setState({ pwdVisible: false });
                    } else {
                        message.error(res.msg, 6);
                    }
                }).catch(err => {
                    message.warn("访问异常");
                }).finally(() => {
                    this.changeFormLoading(false)
                });
            }
        });
    }
    updateLoginname = (e) => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.changeFormLoading(true)
                updateSubAccountResetLoginname(Object.assign({ subUserId: this.state.record.id }, values)).then(res => {
                    if (res.code === 200) {
                        message.success("修改成功!");
                        this.fetchData();
                        this.setState({ loginnameVisible: false });
                    } else {
                        message.error(res.msg, 6);
                    }
                }).catch(err => {
                    message.warn("访问异常");
                }).finally(() => {
                    this.changeFormLoading(false)
                });
            }
        });
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { data, record, formLoading } = this.state;
        const { loginedUser } = this.props;
        const formItemLayout = {
            labelCol: {
                xs: { span: 5 },
                sm: { span: 5 },
            },
            wrapperCol: {
                xs: { span: 17 },
                sm: { span: 17 },
            },
        };
        return (
            <div>
                <Button type="primary" ghost size="small" style={{ marginBottom: 7 }} onClick={(e) => {
                    this.handleModalVisible(true);
                }}>添加子账号</Button> 一个子账号可20人同时登录，授权子账号可签到某些活动，请到「签到」参数，授权给子账号<a href={'https://www.yuque.com/odh2xi/manual/rdi3faeuc977n8vu#blcIr'} target={'_blank'}> 详细帮助</a>。
                <div style={{ margin: '20px 0' }}>子账号登录地址：
                   <CopyToClipboard text={`${window.location.origin}/subaccount-login?orgName=${loginedUser.data.orgName ? loginedUser.data.orgName : ''}`} onCopy={() => message.success("已复制!")}>
                        <a>复制</a>
                    </CopyToClipboard>
                </div>
                <div style={{ margin: '20px 0' }}>子账号导出权限：<Switch
                    checked={this.state.expSwitch}
                    onChange={e => {
                        this.setState({ expSwitch: e });
                        this.updateSubAccountData(e)
                    }}
                    checkedChildren="开启"
                    unCheckedChildren="关闭" />
                </div>
                <div style={{ margin: '20px 0' }}>申请活动必选嘉宾：<Switch
                    checked={this.state.guestSwitch}
                    onChange={e => {
                        this.setState({ guestSwitch: e });
                        this.onHandleSubAccountGuest(e)
                    }}
                    checkedChildren="开启"
                    unCheckedChildren="关闭" />
                </div>
                <div style={{ margin: '20px 0' }}>参与人审核权限：<Switch
                    checked={this.state.AuditSwitch}
                    onChange={e => {
                        this.setState({ AuditSwitch: e });
                        this.updateSubAccountAuditData(e)
                    }}
                    checkedChildren="开启"
                    unCheckedChildren="关闭" />
                </div>
                <div style={{ margin: '20px 0' }}>参与人编辑权限：<Switch
                    checked={this.state.AtendeeSwitch}
                    onChange={e => {
                        this.setState({ AtendeeSwitch: e });
                        this.updateSubAccountAttendeeData(e)
                    }}
                    checkedChildren="开启"
                    unCheckedChildren="关闭" />
                </div>
                {
                    data.length > 0 ?
                        data.map((item, index) => {
                            return (
                                <Card bodyStyle={{ padding: "7px 15px" }} key={index}>
                                    <Row gutter={8}>
                                        <Col span={6}>
                                            <Holder
                                                src={item.avatarUrl}
                                                width={60}
                                                height={60}
                                                size={18}
                                                text={"子"}
                                            />
                                        </Col>
                                        <Col span={14}>
                                            <Row gutter={8}>
                                                <Col span={24}>
                                                    <b>企业或组织名：</b><span>{item.orgName}</span>
                                                </Col>
                                            </Row>
                                            <Row gutter={8}>
                                                <Col span={24}>
                                                    <b>登录名：</b>
                                                    <span>
                                                        {item.loginName}
                                                    </span>
                                                </Col>
                                            </Row>
                                            <Row gutter={8}>
                                                <Col span={24}>
                                                    <b>更新时间：</b><span>{item.modifyTime}</span>
                                                </Col>
                                            </Row>
                                        </Col>
                                        <Col span={4} style={{
                                            height: 60,
                                            display: 'flex',
                                            justifyContent: 'flex-end',
                                            alignItems: 'center'
                                        }}>
                                            <Dropdown overlay={<Menu onClick={(e) => {
                                                if (e.key == '1') {
                                                    this.showModalVisiblePwd(item)
                                                }
                                                if (e.key == '2') {
                                                    this.showModalVisibleLoginname(item)
                                                }
                                                if (e.key == '3') {
                                                    this.showCheckinpointModal(item.id)
                                                }

                                            }}>
                                                <Menu.Item key="1">重置密码</Menu.Item>
                                                <Menu.Item key="2">重置登录名</Menu.Item>
                                                <Menu.Item key="3">管理签到权限</Menu.Item>
                                            </Menu>}>
                                                <a ><Icon style={{ fontSize: 14 }} type='setting' /></a>
                                            </Dropdown>
                                            <span className="ant-divider" ></span>
                                            <Popconfirm title={<span>您确定要删除 <span className="mdc-text-red">{item.loginName}</span>吗?</span>}
                                                onConfirm={(e) => {
                                                    this.handleDelSubAccount(item.id);
                                                }}>
                                                <a><Icon style={{ fontSize: 14 }} type='delete' /></a>
                                            </Popconfirm>
                                            {/* <a href="#" onClick={() => this.showModalVisiblePwd(item)}>重置密码</a>
                                            <a href="#" onClick={() => this.showModalVisibleLoginname(item)}>重置登录名</a>
                                            <a href="#" onClick={() => this.showCheckinpointModal(item.id)}>管理签到权限</a> */}
                                        </Col>
                                    </Row>
                                </Card>
                            );
                        })
                        :
                        <p style={{ color: '#959595' }}>目前还未添加任何子账号</p>
                }

                <Modal
                    visible={this.state.visible}
                    title="添加子账号，注意：一个子账号可以同时20人一起登录"
                    width="550px"
                    confirmLoading={formLoading}
                    onCancel={() => this.handleModalVisible(false)}
                    onOk={() => this.submitForm()}
                >
                    {this.state.visible &&
                        <Form>
                            <Form.Item
                                {...formItemLayout}
                                label="企业或组织名"
                            >
                                <span>{loginedUser.data.orgName}</span>

                            </Form.Item>
                            <Form.Item
                                {...formItemLayout}
                                label="登录名"
                            >
                                {getFieldDecorator('loginName', {
                                    rules: [
                                        { required: true, message: '请输入登录名' },
                                        { min: 1, max: 15, message: '登录名最多15字，建议2-8字' },
                                        { pattern: /^[\u4e00-\u9fa5\uff08\uff09a-zA-Z0-9\(\)]+$/, message: '不能使用非法字符' }
                                    ],
                                })(
                                    <Input placeholder="子账号，可中文，如：张老师" autoComplete="off" />
                                )}
                            </Form.Item>
                            <Form.Item
                                {...formItemLayout}
                                label="登录密码"
                            >
                                {getFieldDecorator('passwd', {
                                    rules: [{
                                        required: true, message: '输入你的登录密码!',
                                    },
                                    { type: "string", min: 6, max: 20, message: '长度限制为6至20个之间!' },],
                                })(
                                    <Input type="password" />
                                )}
                            </Form.Item>
                        </Form>}
                </Modal>
                <Modal
                    visible={this.state.pwdVisible}
                    title="重置密码"
                    width="550px"
                    confirmLoading={formLoading}
                    onCancel={() => this.setState({ pwdVisible: false })}
                    onOk={() => this.updatePwd()}
                >
                    {this.state.pwdVisible &&
                        <Form>
                            <Form.Item
                                {...formItemLayout}
                                label="企业或组织名"
                            >
                                <span>{loginedUser.data.orgName}</span>

                            </Form.Item>
                            <Form.Item
                                {...formItemLayout}
                                label="登录名"
                            >
                                <span>{record.loginName}</span>
                            </Form.Item>
                            <Form.Item
                                {...formItemLayout}
                                label="重置密码"
                            >
                                {getFieldDecorator('newPwd', {
                                    rules: [{
                                        required: true, message: '输入你的登录密码!',
                                    },
                                    { type: "string", min: 6, max: 20, message: '长度限制为6至20个之间!' },],
                                })(
                                    <Input type="password" />
                                )}
                            </Form.Item>
                        </Form>}
                </Modal>
                <Modal
                    visible={this.state.loginnameVisible}
                    title="重置登录名"
                    width="550px"
                    confirmLoading={formLoading}
                    onCancel={() => this.setState({ loginnameVisible: false })}
                    onOk={() => this.updateLoginname()}
                >
                    {this.state.loginnameVisible &&
                        <Form>
                            <Form.Item
                                {...formItemLayout}
                                label="企业或组织名"
                            >
                                <span>{loginedUser.data.orgName}</span>

                            </Form.Item>
                            <Form.Item
                                {...formItemLayout}
                                label="登录名"
                            >
                                {getFieldDecorator('loginName', {
                                    rules: [{
                                        required: true, message: '输入你的登录名!',
                                    },
                                    { type: "string", min: 2, max: 30, message: '长度限制为2至30个之间!' },],
                                })(
                                    <Input />
                                )}
                            </Form.Item>
                        </Form>}
                </Modal>
                <Modal
                    width={600}
                    bodyStyle={{ paddingTop: 10 }}
                    title="解除签到权限"
                    visible={this.state.checkinpointVisible}
                    onCancel={() => this.setState({ checkinpointVisible: false })}
                    footer={null}
                >
                    <Table
                        columns={this.checkinpointColumns}
                        // showHeader={false}
                        loading={this.state.checkinpointResponse.isFetching}
                        dataSource={this.state.checkinpointResponse.data}
                        pagination={false}
                        scroll={{ x: 546, y: 'calc(100vh - 518px)' }}
                    />

                </Modal>
            </div>
        );
    }
}

const SubAccLists = connect(mapStateToPorps, mapDispatchToProps)(Form.create()(SubAccList));

class SubAccounts extends React.Component {
    constructor(props) {
        super(props);
        this.pstView = null;
        this.state = {
            visible: false,
            formLoading: false,
            validity: false,

        }


    }

    componentDidMount() {
        isValidity('SUBACCOUNT', (vaild) => {
            this.setState({
                validity: vaild
            })
        })

    }
    changeFormLoading = (loading) => {
        this.setState({
            formLoading: loading
        })
    }
    handleModalVisible = (flag) => {
        this.setState({ visible: flag });
    }

    submitForm = (e) => {
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.changeFormLoading(true)
                createOrgName(Object.assign({ userId: 'default' }, values)).then(res => {
                    if (res.code === 200) {
                        message.success("申请成功!");
                        this.props.fetchLoginedUser();
                        this.handleModalVisible(false);
                    } else {
                        message.error(res.msg, 6);
                    }
                }).catch(err => {
                    message.warn("访问异常");
                }).finally(() => {
                    this.changeFormLoading(false)
                });
            }
        });
    }



    render() {
        const { visible, formLoading } = this.state
        const { getFieldDecorator } = this.props.form;
        const { loginedUser } = this.props;
        const formItemLayout = {
            labelCol: {
                xs: { span: 5 },
                sm: { span: 5 },
            },
            wrapperCol: {
                xs: { span: 17 },
                sm: { span: 17 },
            },
        };



        return (
            <ASBody>
                {loginedUser.data &&
                    (loginedUser.data.orgName ?
                        <SubAccLists />
                        :
                        <div style={{ textAlign: 'center', paddingTop: 114 }}>
                            <Button type="primary" onClick={() => {
                                this.state.validity ? this.handleModalVisible(true) : this.pstView.show()
                            }}>
                                <Icon type="plus" />
                            绑定子账号企业或组织名
                        </Button>
                            <p style={{ marginTop: 8, color: '#959595' }}>高级会员，绑定企业或组织名，仅用于子账号登录，不可修改。<a href="https://www.yuque.com/odh2xi/manual/rdi3faeuc977n8vu#blcIr" target="_blank">详细操作步骤</a></p>
                        </div>)}






                <Modal
                    visible={visible}
                    title="绑定企业或组织名"
                    width="550px"
                    confirmLoading={formLoading}
                    onCancel={() => this.handleModalVisible(false)}
                    onOk={() => this.submitForm()}
                >
                    <Form>

                        <Form.Item
                            {...formItemLayout}
                            label="企业或组织名"
                        >
                            {getFieldDecorator('orgName', {
                                rules: [
                                    { required: true, message: '请输入企业或组织名' },
                                    { min: 1, max: 30, message: '企业或组织名最多15字符，建议2-8字符' },
                                    { pattern: /^[\u4e00-\u9fa5\uff08\uff09a-zA-Z0-9\(\)]+$/, message: '不能使用非法字符' }
                                ],
                            })(
                                <Input placeholder="企业或组织名，可中文，建议公司简称，如：华为技术" autoComplete="off" />
                            )}
                        </Form.Item>

                    </Form>
                </Modal>

                <PurchaseServiceTips
                    ref={(pst) => {
                        this.pstView = pst
                    }}
                    member={'SENIORMEMBER'}

                />


            </ASBody>

        )
    }
}





export default connect(mapStateToPorps, mapDispatchToProps)(Form.create()(SubAccounts));



// WEBPACK FOOTER //
// ./src/containers/usersfrom/SubAccounts.jsx